import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  Row,
  Col,
} from "reactstrap";
import DataTable from "react-data-table-component";
import SweetAlert from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { H3, Btn, Breadcrumbs, H4 } from "../../../AbstractElements";
import {
  Search,
  Filter,
  Export,
  Import,
  Enquiry,
  EnquiryList,
  newEnquiry,
} from "../../../Constant";
import "jspdf-autotable";
import Popup from "../../Common/Popup/Popup";
import {
  showEnquiry,
  deleteEnquiry,
  getStaff,
  enquirystatusCount,
} from "../../../CommonURL";

import {
  getDataWithToken,
  getClientUrlDataToken,
  postDataWithToken,
} from "../../../Utils/restUtils";

import Transparentspinner from "../../Common/loader/Transparentspinner";
import { toast } from "react-toastify";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import Widgets from "../../Common/Progress/Widgets";
import OverDues from "./OverDues";
import EnquiryImportModal from "./EnquiryImportModal";

const EnquiriesList = () => {
  const navigate = useNavigate();

  const [spinnerTrans, setspinnerTrans] = useState(false);

  const [customerLists, setCustomerList] = useState([]);
  const [users, setUsers] = useState([]);
  const [itemOption, setitemsoptions] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [tempIndustry, setTempIndustry] = useState("");
  const [staticwidgets, setstaticwidgets] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [importDrpodown, setimportDrpodown] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");

  const [isIndustry, setIsIndustry] = useState("");

  const [isStatus, setIsStatus] = useState("");
  const [tempStatus, setTempStatus] = useState("");

  const [isUser, setIsUser] = useState("");
  const [tempUser, setTempUser] = useState("");

  const [isProduct, setIsProduct] = useState("");
  const [tempProduct, setTempProduct] = useState("");

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [sortConfig, setSortConfig] = useState({
    column: "",
    order: "",
  });
  const [modalImport, setModalImport] = useState(false);

  const handleOpenImport = () => {
    setModalImport(!modalImport);
  };

  const handleNavigateLog = () => {
    navigate("/lead-manage/enquiry/imported-log-list");
  };

  const formatStartDate = startDate
    ? moment(startDate).format("DD-MM-YYYY")
    : "";

  const formatEndDate = endDate ? moment(endDate).format("DD-MM-YYYY") : "";

  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const enquiryStatusOptions = [
    { label: "New", value: "new" },
    { label: "Contacted", value: "contacted" },
    { label: "Qualified", value: "qualified" },
    { label: "Lost", value: "lost" },
    { label: "Converted", value: "converted" },
  ];

  useEffect(() => {
    getEnquiryData();
  }, [
    currentPage,
    perPage,
    sortConfig,
    searchKeyword,
    isStatus,
    isUser,
    isProduct,
    isIndustry,
  ]);

  useEffect(() => {
    getwidgetsdata();
    userData();
  }, []);

  const getEnquiryData = async () => {
    setspinnerTrans(true);

    try {
      const response = await getDataWithToken(
        `${showEnquiry}?page=${currentPage}
        &page_length=${perPage}
        &search=${searchKeyword || ""}
        &status=${isStatus || ""}
        &user_id=${isUser || ""}
        &industry_type_id=${isIndustry || ""}
        &start_date=${formatStartDate || ""}
        &end_date=${formatEndDate || ""}
        &sort_by=${sortConfig.column || ""}
        &sort_order=${sortConfig.order || ""}
        &product_id=${isProduct || ""}`,
      );

      if (response.status === true) {
        setTotalRows(response.data.total);

        setCustomerList(
          response.data.data.map((e, index) => ({
            Si: (currentPage - 1) * perPage + index + 1,
            id: e.id,
            enquiryId: e.enquiry_id || "N/A",
            Name: e.name || "N/A",
            Mobile: e.phone
              ? `${e.country_code ? `${e.country_code} ` : ""}${e.phone}`
              : "N/A",
            Email: e.email || "N/A",
            Company: e.company || "N/A",
            Address: e.address || "N/A",
            City: e.city || "N/A",
            State: e.state || "N/A",
            Country: e.country || "N/A",
            Source: e.source || "N/A",
            Status: e.status || "N/A",
            Notes: e.notes || "N/A",
            AssignedTo: e.assigned_user_name || "N/A",
            Industry: e.industry_name || "N/A",
            Created: e.created_at || "N/A",
          })),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setspinnerTrans(false);
    }
  };

  const userData = async () => {
    const data = await getDataWithToken(getStaff);

    if (data.status === true) {
      setUsers(data.data.data);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();

    setSearchKeyword(tempSearch);
    setIsStatus(tempStatus);
    setIsUser(tempUser);
    setIsProduct(tempProduct);
    setIsIndustry(tempIndustry?.value || "");
    setCurrentPage(1);
  };

  const handleSort = (column) => {
    let newOrder = "asc";

    if (sortConfig.column === column.id) {
      newOrder = sortConfig.order === "asc" ? "desc" : "asc";
    }

    setSortConfig({
      column: column.id,
      order: newOrder,
    });
  };
  const handleApiError = (status) => {
    if (status >= 400 && status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (status >= 500 && status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  const getwidgetsdata = async () => {
    const data = await getDataWithToken(enquirystatusCount);
    if (data?.status === true) {
      setstaticwidgets(data.data);
    } else {
      handleApiError(data.status);
    }
  };

  const toggleImport = () => setimportDrpodown(!importDrpodown);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const exportCustomerExcel = async () => {
    setspinnerTrans(true);

    try {
      const response = await getDataWithToken(
        `${showEnquiry}?export=customer_data
      &search=${searchKeyword || ""}
      &status=${isStatus || ""}
      &user_id=${isUser || ""}
      &industry_type_id=${isIndustry || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`,
      );

      const dataToExport = response.data.data.map((e) => ({
        Enquiry_Id: e.enquiry_id,
        Name: e.name,
        Mobile: e.phone,
        Company: e.company,
        Industry: e.industry_name,
        Status: e.status,
        Assigned_To: e.assigned_user_name,
        Created_On: e.created_at,
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, "Enquiry Data");

      XLSX.writeFile(wb, "enquiry_report.xlsx");
    } catch (error) {
      console.log(error);
    } finally {
      setspinnerTrans(false);
    }
  };

  const exportCustomerPdf = async () => {
    setspinnerTrans(true);

    try {
      const response = await getDataWithToken(
        `${showEnquiry}?export=customer_data
      &search=${searchKeyword || ""}
      &status=${isStatus || ""}
      &user_id=${isUser || ""}
      &industry_type_id=${isIndustry || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`,
      );

      const rows = response.data.data.map((e, index) => [
        index + 1,
        e.enquiry_id || "",
        e.name || "",
        e.phone || "",
        e.company || "",
        e.status || "",
        e.assigned_user_name || "",
        e.created_at || "",
      ]);

      const doc = new jsPDF();

      doc.setFontSize(16);
      doc.text("Enquiry Report", 14, 15);

      autoTable(doc, {
        startY: 25,
        head: [
          [
            "Sl",
            "Enquiry Id",
            "Name",
            "Mobile",
            "Company",
            "Status",
            "Assigned To",
            "Created On",
          ],
        ],
        body: rows,
        styles: {
          fontSize: 8,
        },
        headStyles: {
          fillColor: [41, 128, 185],
        },
      });

      doc.save("enquiry_report.pdf");
    } catch (error) {
      console.log("PDF Export Error:", error);
    } finally {
      setspinnerTrans(false);
    }
  };
  const ActionCell = ({ row }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleEditClick = () => {
      navigate(
        `${process.env.PUBLIC_URL}/lead-manage/editEnquiry?id=${row.id}`,
      );
    };
    const deleteEnquiryData = (row) => {
      SweetAlert.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this enquiry!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          setspinnerTrans(true);

          try {
            const deleteRes = await postDataWithToken(deleteEnquiry, {
              enquiry_id: row.id,
            });

            if (deleteRes?.data?.status === true) {
              SweetAlert.fire(
                "Deleted!",
                "Enquiry has been deleted.",
                "success",
              );

              toast.success(deleteRes?.data?.message);

              getEnquiryData();
            } else {
              toast.error(deleteRes?.data?.message || "Something went wrong");
            }
          } catch (error) {
            toast.error("Something went wrong");
          } finally {
            setspinnerTrans(false);
          }
        }
      });
    };

    const handleView = () => {
      navigate(
        `${process.env.PUBLIC_URL}/lead-manage/enquiry-details?id=${row.id}`,
      );
    };

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>

        <DropdownMenu container="body">
          <DropdownItem style={toggleStyle} onClick={handleView}>
            View
          </DropdownItem>

          {row.Status?.toLowerCase() !== "converted" && (
            <DropdownItem style={toggleStyle} onClick={handleEditClick}>
              Edit
            </DropdownItem>
          )}
          <DropdownItem
            style={{
              padding: "10px 20px",
              color: "red",
              opacity: "0.8",
              fontSize: "14px",
              margin: "0",
            }}
            onClick={() => deleteEnquiryData(row)}
          >
            Delete{" "}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const enquiryColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Si,
      sortable: true,
      width: "80px",
      center: true,
    },
    {
      name: <i className="fa fa-gears"></i>,
      cell: (row) => <ActionCell row={row} />,
      width: "70px",
      center: true,
    },
    {
      name: <H4>Enquiry Id</H4>,
      selector: (row) => (
        <Link
          style={{ textDecoration: "underline" }}
          to={`${process.env.PUBLIC_URL}/lead-manage/enquiry-details?id=${row.id}`}
        >
          {row.enquiryId}
        </Link>
      ),
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: <H4>Name</H4>,
      selector: (row) => row.Name,
      sortable: true,
      wrap: true,
    },
    {
      name: <H4>Industry Name</H4>,
      selector: (row) => row.Industry,
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: <H4>Company</H4>,
      selector: (row) => row.Company,
      sortable: true,
      wrap: true,
    },
    {
      name: <H4>Mobile</H4>,
      selector: (row) => row.Mobile,
      sortable: true,
      wrap: true,
      width: "140px",
    },
    {
      name: <H4>Assigned To</H4>,
      selector: (row) => row.AssignedTo,
      id: "assigned",
      sortable: true,
      wrap: true,
      minWidth: "160px",
    },

    {
      name: <H4>Source</H4>,
      selector: (row) => row.Source,
      sortable: true,
      wrap: true,
    },
    {
      name: <H4>Status</H4>,
      selector: (row) => row.Status,
      cell: (row) => (
        <span className={` badge-${row.Status}`}>{row.Status}</span>
      ),
      sortable: true,
      wrap: true,
      width: "110px",
    },
  ];

  return (
    <Fragment>
      {spinnerTrans && <Transparentspinner />}

      <Breadcrumbs
        mainTitle={Enquiry}
        parent="Lead Manager"
        title={EnquiryList}
      />
      <Widgets details={staticwidgets} />
      <OverDues />
      <Card className="cardWidth mt-4">
        <CardHeader
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <H3>{EnquiryList}</H3>

          <div className="d-flex gap-2">
            <Link
              to={`${process.env.PUBLIC_URL}/lead-manage/addEnquiry`}
              className="btn btn-primary"
            >
              {newEnquiry}
            </Link>

            {/* <Dropdown isOpen={importDrpodown} toggle={toggleImport}>
              <DropdownToggle className="btn btn-primary">
                {Import}
              </DropdownToggle>

              <DropdownMenu container="body">
                <DropdownItem onClick={handleOpenImport}>
                  Import Enquiry
                </DropdownItem>

                <DropdownItem onClick={handleNavigateLog}>
                  Imported Enquiry Logs
                </DropdownItem>
              </DropdownMenu>
            </Dropdown> */}

            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle
                className="btn btn-primary"
                color="#fff"
                style={{ fontSize: "14px", zIndex: 1000 }}
              >
                {Export}
                <i className="icofont icofont-arrow-up"></i>
              </DropdownToggle>

              <DropdownMenu container="body">
                <DropdownItem onClick={exportCustomerExcel}>Excel</DropdownItem>

                <DropdownItem onClick={exportCustomerPdf}>PDF</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </CardHeader>

        <Form className="px-4 pb-2" onSubmit={handleFilter}>
          <Row className="g-3 align-items-center">
            <Col sm="12" md="3">
              <input
                className="form-control"
                value={tempSearch}
                onChange={(e) => setTempSearch(e.target.value)}
                placeholder={Search}
              />
            </Col>

            <Col sm="12" md="5" lg="3" className="form-element">
              <div style={{ position: "relative", zIndex: 2 }}>
                <DatePicker
                  className="form-control digits w-100"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  isClearable={startDate ? true : false}
                  monthsShown={2}
                  popperPlacement="bottom"
                  calendarClassName="parallel-calendar"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select Date Range"
                />
              </div>
            </Col>
            <Col sm="12" md="5" lg="3" className="form-element">
              <IndustryFilter
                IsIndustry={tempIndustry}
                setIsIndustry={setTempIndustry}
              />
            </Col>
            <Col sm="12" md="2">
              <select
                value={tempUser}
                onChange={(e) => setTempUser(e.target.value)}
                className="form-control"
              >
                <option value="">Assigned User</option>

                {users?.map((item) => (
                  <option key={item.user_id} value={item.id}>
                    {item.first_name}
                  </option>
                ))}
              </select>
            </Col>

            <Col sm="12" md="2">
              <select
                value={tempStatus}
                onChange={(e) => setTempStatus(e.target.value)}
                className="form-control"
              >
                <option value="">Status</option>

                {enquiryStatusOptions?.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </Col>

            <Col sm="12" md="2">
              <Btn attrBtn={{ color: "primary" }} type="submit">
                {Filter}
              </Btn>
            </Col>
          </Row>
        </Form>
        <Popup
          isOpen={modalImport}
          title={"Import Enquiry"}
          toggler={handleOpenImport}
        >
          <EnquiryImportModal
            currentPage={currentPage}
            tablerenderFunc={getEnquiryData}
            setModal={setModalImport}
          />
        </Popup>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              pagination
              paginationServer
              columns={enquiryColumns}
              data={customerLists}
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              onSort={handleSort}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              sortServer
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default EnquiriesList;
